import SalesforceLogo from "@appsmith/carbon-connect/src/assets/logos/salesforce.svg";
import SlackLogo from "@appsmith/carbon-connect/src/assets/logos/slack.svg";
import ZendeskLogo from "@appsmith/carbon-connect/src/assets/logos/zendesk.svg";
import JiraLogo from "@appsmith/carbon-connect/src/assets/logos/jira.svg";
import GoogleDriveLogo from "@appsmith/carbon-connect/src/assets/logos/google_drive.svg";
import NotionLogo from "@appsmith/carbon-connect/src/assets/logos/notion.svg";

export const INTEGRATIONS_ICONS = {
  NOTION: NotionLogo,
  SLACK: SlackLogo,
  SALESFORCE: SalesforceLogo,
  ZENDESK: ZendeskLogo,
  JIRA: JiraLogo,
  GOOGLE_DRIVE: GoogleDriveLogo,
};
